import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"
import { getApiConfig } from "shared/api"

const { BASE_URL } = getApiConfig()
const ME_PATH = "me"

function getMeApi() {
  // Читаем токен при каждом вызове, чтобы не полагаться на значение, захваченное при загрузке модуля
  const accessToken = localStorage.getItem("accessToken")
  
  // Если токена нет, не делаем запрос
  if (!accessToken) {
    return Promise.reject(new Error("No access token available"))
  }

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  }

  const token = accessToken.startsWith("Bearer ")
    ? accessToken
    : `Bearer ${accessToken}`
  headers.Authorization = token

  return axios
    .get(`${BASE_URL}/${ME_PATH}`, { headers })
    .then(({ data }) => {
      if (data && data.data) {
        return data.data // Возвращаем данные пользователя, если структура корректная
      }
      throw new Error("Invalid response structure")
    })
    .catch((error) => {
      // Если получили 401, очищаем токен
      if (error.response?.status === 401) {
        localStorage.removeItem("accessToken")
        localStorage.removeItem("refreshToken")
      }
      throw error
    })
}

export const getMeData = createAsyncThunk("main/getMeData",
  async (_, {rejectWithValue}) => {
    try {
      const { user } = await getMeApi()
      return user
    } catch (error) {
      return rejectWithValue(error.message)
    }
})

export const mainSlice = createSlice({
  name: "main",
  initialState: {
    isAdmin: true,
    isAuth: false,
    user: null,
    checkingIsAuth: false
  },
  reducers: {
    updatedIsAuth: (state, { payload: { isAuth, user } }) => {
      state.isAuth = isAuth
      if (!isAuth) {
        localStorage.removeItem("accessToken")
      }
      if (user) state.user = user
    },
    setPermission: (state, { payload }) => {
      state.isAdmin = payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getMeData.pending, state => {
        state.checkingIsAuth = true
      })
      .addCase(getMeData.fulfilled, (state, { payload }) => {
        state.user = payload
        state.isAuth = true
        state.checkingIsAuth = false
      })
      .addCase(getMeData.rejected, (state, { payload }) => {
        state.user = null
        state.isAuth = false
        state.checkingIsAuth = false
      })
  }
})

export const { updatedIsAuth, setPermission } = mainSlice.actions